import {AnimatePresence, motion} from 'framer-motion'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Hi(){
    const navigator=useNavigate()
    const [tex,changetex]=useState(false)
    setTimeout(()=>{
        changetex(true)
    },1700)
    setTimeout(()=>{
        navigator('/main')
    },4100)
    return <AnimatePresence mode='wait'>
    {(!tex)&&<motion.div 
    key={"hi"}
    initial={{
        opacity:0,
        y:-50
    }}
   animate={{
       opacity:1,
       y:0
   }} 
   transition={{
    delay:0.3,
    duration:0.7
   }}
   exit={{
       opacity:0,
       y:-50
   }}
    style={{
        height:"100vh",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        color:"white",
        fontSize:"10rem",
        fontWeight:"100px"
    }}>
        Hi.
    </motion.div>}
    {(tex)&&<motion.div 
    key={"iam"}
    initial={{
        opacity:0,
        y:60
    }}
   animate={{
       opacity:1,
       y:0
   }} 
   transition={{
    delay:0.3,
    duration:0.7
   }}
   exit={{
       opacity:0,
   }}
    style={{
        height:"100vh",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        color:"white",
        fontSize:"10rem",
        fontWeight:"200"
    }}>
        I am
    </motion.div>}
    
    </AnimatePresence>
    
}